var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {},
      [
        _c("jFloatingPrompt", { ref: "flowFloating" }, [
          _c("h2", { staticClass: "inline--block" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.flow.name) +
                " -\n        " +
                _vm._s(_vm.flow.type_name === "ORDER" ? "IN" : "") +
                "\n        " +
                _vm._s(_vm.flow.type_name) +
                "\n        " +
                _vm._s(
                  _vm.flow.minimum_action !== 0 ? _vm.flow.minimum_action : ""
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrap-button-flow" },
            [
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.UpdateFlow } },
                [_vm._v("\n          UPDATE\n        ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue outline",
                  on: { click: _vm.flowDeleted }
                },
                [_vm._v("\n          DELETE\n        ")]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa fa-times",
                on: { click: _vm.hideFlowFloating }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "overflow-scroll" }, [
            _vm.flow.use_division_chart === false
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "inline--block bullet" }, [
                      _c("div", { staticClass: "flow-new__bullet-top" }, [
                        _c("i", { staticClass: "fa fa-square" })
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.flow.members, function(approver, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "approver-order inline--block"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "inline--block line-wrap" },
                            [_c("div", { staticClass: "line-horizontal" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "inline--block box-flow" }, [
                            _c("div", { staticClass: "header-flow" }, [
                              _c("div", { staticClass: "header-actions" }, [
                                _c("i", { staticClass: "fa fa-edit" }),
                                _vm._v(" "),
                                _c("i", { staticClass: "fa fa-times" })
                              ]),
                              _vm._v(
                                "\n                Approver " +
                                  _vm._s(approver.order) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "content-flow" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(approver.organigram.name) +
                                  "\n              "
                              )
                            ])
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b289cc22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b289cc22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/jFlowFloatingPrompt.vue
// module id = null
// module chunks = 